module.exports = __webpack_public_path__ + "img/share.bdf83988.png";